import { render } from "./TelegramBroadcastAudienceSpecForm.vue?vue&type=template&id=d551fba0&ts=true"
import script from "./TelegramBroadcastAudienceSpecForm.vue?vue&type=script&lang=ts"
export * from "./TelegramBroadcastAudienceSpecForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__